import { Button, Flex, Spacing, Text } from '@billy/design-system'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface InvoicingSettingsLoadErrorMessageProps {
  onRetry: () => Promise<unknown>
}

export const InvoicingSettingsLoadErrorMessage = ({
  onRetry,
}: InvoicingSettingsLoadErrorMessageProps): ReactElement => {
  const { t } = useTranslation()

  const handleRetryButtonClick = useCallback(() => onRetry(), [onRetry])

  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={Spacing.S16}>
      <Text>{t('something_went_wrong')}</Text>
      <Button onClick={handleRetryButtonClick} variant="outlined">
        {t('invoicing_settings.try_again')}
      </Button>
    </Flex>
  )
}
